import React, { useState } from "react";
import { Modal, Upload, Button, Typography } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { addExecuter } from "./SkeyeingestExecutorApi";
import { extractMsg } from "../../../utils/errorUtils";

const { Dragger } = Upload;

export default function SkeyeingestAddExecutorDialog({
  open,
  onClose,
  onSuccess,
  messageApi,
}) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (!file) {
      messageApi.warning("Please select a .jar file first.");
      return;
    }
    if (!file.name.endsWith(".jar")) {
      messageApi.error("Only .jar files are allowed.");
      return;
    }

    setLoading(true);
    try {
      const response = await addExecuter({ file, filename: file.name });
      if (response.status === 200 || response.status === 201) {
        messageApi.success("Executor added successfully.");
        setFile(null);
        onSuccess();
        onClose();
      }
    } catch (error) {
      messageApi.error({
        content: extractMsg(error, "Failed to add executor"),
        key: "add-executor-error",
      });
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    accept: ".jar",
    beforeUpload: (f) => {
      if (f.size > 256 * 1024 * 1024) {
        messageApi.error("File size exceeds the 256 MB limit");
        return Upload.LIST_IGNORE;
      }
      setFile(f);
      return false;
    },
    onRemove: () => setFile(null),
    fileList: file ? [file] : [],
    maxCount: 1,
  };

  return (
    <Modal
      title="Add New Executor"
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
    >
      <Dragger
        {...uploadProps}
        style={{ padding: "20px", marginBottom: "24px" }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined style={{ color: "#e29b45" }} />
        </p>
        <p className="ant-upload-text">
          Click or drag .jar file to this area to upload
        </p>
        <Typography.Text type="secondary">
          Strictly only accepts valid Java Archive (.jar) files (Max 256 MB).
        </Typography.Text>
      </Dragger>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          onClick={onClose}
          disabled={loading}
          style={{ backgroundColor: "#D97A07", color: "#fff", border: "none" }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={handleSave}
          loading={loading}
          style={{ backgroundColor: "#0D2E4D" }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
}
